module.exports = __webpack_public_path__ + "static/Kwera_Credits_Close-344326cf75cb6014890a2ade7ed1f674.png";